import React, { useEffect, useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import "./CompareSlider.css";

const ModelImage = ({ model, clipId }) => (
  <svg className="cmp-img" viewBox={model.viewport.join(" ")} role="img" aria-label={model.alt} focusable="false">
    <defs>
      <clipPath id={clipId}>
        <rect x={model.viewport[0]} y={model.viewport[1]} width={model.viewport[2]} height={model.viewport[3]} />
      </clipPath>
    </defs>
    <image href={model.src} width={model.imageWidth} height={model.imageHeight} clipPath={`url(#${clipId})`} />
  </svg>
);

/** Comparateur accessible rendu métal ↔ représentation CAO. */
const CompareSlider = ({ before, after, initial = 50 }) => {
  const [pos, setPos] = useState(initial);
  const touched = useRef(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || document.body.classList.contains("reduce-motion")) return undefined;
    let frame;
    const start = performance.now() + 700;
    const duration = 1500;
    const tick = (now) => {
      if (touched.current) return;
      const t = Math.min(Math.max((now - start) / duration, 0), 1);
      setPos(initial + Math.sin(t * Math.PI) * 9);
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [initial]);

  const onChange = (e) => {
    touched.current = true;
    setPos(Number(e.target.value));
  };

  return (
    <div className="cmp" style={{ "--pos": `${pos}%` }} data-testid="compare-slider">
      <ModelImage model={after} clipId="compare-after-crop" />
      <div className="cmp-before" aria-hidden="true">
        <ModelImage model={before} clipId="compare-before-crop" />
      </div>

      <span className="cmp-tag cmp-tag-before" aria-hidden="true">{before.label}</span>
      <span className="cmp-tag cmp-tag-after" aria-hidden="true">{after.label}</span>

      <div className="cmp-line" aria-hidden="true" />
      <div className="cmp-knob" aria-hidden="true">
        <MoveHorizontal size={18} strokeWidth={2.2} />
      </div>

      <input
        type="range"
        className="cmp-range"
        min="0"
        max="100"
        step="0.5"
        value={pos}
        onChange={onChange}
        onPointerDown={() => { touched.current = true; }}
        aria-label="Comparer le rendu métal et la vue CAO de la plateforme"
        aria-valuetext={`${Math.round(pos)} % rendu métal, ${100 - Math.round(pos)} % modèle CAO`}
        data-testid="compare-range"
      />
    </div>
  );
};

export default CompareSlider;
